<template>
  <!-- App Bar -->
  <v-app-bar app :color="navBarColor" dark elevation="1">
    <v-btn v-if="backArrow" icon="mdi-arrow-left" @click="returnToPage()"></v-btn>
    <v-app-bar-nav-icon v-else @click="toggleDrawer" />
    <v-toolbar-title v-if="!isProviderView" class="d-none d-sm-flex">{{ pageTitle }}</v-toolbar-title>
    <v-toolbar-title v-else >{{ pageTitle }}</v-toolbar-title>

    <!-- Action Buttons -->
    <template v-slot:append v-if="!disableActions">
      <v-btn class="sos" @click="goToPage('SOS')">SOS</v-btn>
      <v-btn icon="mdi-bell-outline" @click="goToPage('Notifications')"></v-btn>
      <v-btn icon="mdi-cog-outline" @click="goToPage('Settings')"></v-btn>

      <!-- Messages Icon -->
      <v-btn icon="mdi-email-outline" @click="goToPage('Inbox')"></v-btn>

      <!-- Profile Icon -->
      <!-- Profile Dropdown -->
      <div class="text-center">
          <v-menu
          >
            <template v-slot:activator="{ props }">
              <v-btn
                v-bind="props"
                icon="mdi-account"
              >
                
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="goToPage('Profile')">
                <v-list-item-title>Profile</v-list-item-title>
              </v-list-item>
              
              <v-list-item @click="logout">
                <v-list-item-title>Logout</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
    </template>
  </v-app-bar>

  <!-- Navigation Drawer -->
  <MainMenu v-model="drawer" v-if="!disableMenu"></MainMenu>
</template>

<script>
import MainMenu from "./MainMenu.vue";
import axios from "axios";

export default {
  name: "NavBar",
  props: {
    backArrow: Boolean,
    disableActions: Boolean,
    disableMenu: Boolean,
    isProviderView: {
      default: false, 
      type: Boolean
    },
    pageTitle: {
      default: "",
      type: String,
    },
  },
  components: {
    MainMenu,
  },
  data() {
    return {
      drawer: false,
      navBarColor: "aqua-teal",
    };
  },
  mounted() {
    console.log(this.isProviderView);
    if(this.isProviderView){
      this.navBarColor = (this.isProviderView) ? "white" : "aqua-teal"; 
    }
  },
  methods: {
    toggleDrawer() {
      this.drawer = !this.drawer;
    },
    returnToPage() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else this.$router.push("Home");
    },
    goToPage(variable) {
      this.$router.push({ name: variable });
    },
    async logout() {
      try {
        axios.defaults.baseURL = process.env.VUE_APP_API_URL;
        const response = await axios.post("/api/auth/logout", null, {
          withCredentials: true,
        });
        if (response.status === 200) {
          localStorage.clear();  // Clear all local storage in the domain
          this.$router.push({ name: "LoginPage" });
        } else {
          console.error(`Logout failed: ${response.statusText}`);
        }
      } catch (error) {
        console.error("Logout error:", error);
      }
    },
  },
};
</script>

<style scoped>
.sos {
  font-size: 16px;
  background-color: #ff0000;
}

.aqua-teal {
  background-color: #08b6aa;
}

.top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  padding: 10px 15px;
  height: 60px;
  border-bottom: 2px solid #293840;
}
</style>
